import React from 'react';
import { stateKeys } from '../constants';
import { DataPreparationProvider } from '../services/dataPreparation';
import { FilterProvider } from '../services/filter';
import { HeaderSizeCalculatorProvider } from '../services/headerSizeCalculator';
import { PageProvider } from '../services/page';
import { PageSizeProvider } from '../services/pageSize';
import { RowExpansionProvider } from '../services/rowExpansion';
import { RowSelectionProvider } from '../services/rowSelection';
import { TemplateColumnsCalculatorProvider } from '../services/templateColumnsCalculator';
import { StateProvider } from '../stateManager';

const initialState = {
  [stateKeys.selectedRowKeys]: [],
  [stateKeys.expandedRowKeys]: [],
  [stateKeys.preparedDataIdsSet]: new Set(),
  [stateKeys.page]: 1,
  [stateKeys.pageSize]: 10,
};

const providers = [
  { Provider: StateProvider, props: { initialState } },
  { Provider: PageProvider, props: (props) => props.pageConfig },
  { Provider: FilterProvider, props: (props) => props.filterConfig },
  {
    Provider: RowSelectionProvider,
    props: (props) => props.rowSelectionConfig,
  },
  {
    Provider: RowExpansionProvider,
    props: (props) => props.rowExpansionConfig,
  },
  { Provider: PageSizeProvider, props: (props) => props.pageSizeConfig },
  {
    Provider: DataPreparationProvider,
    props: (props) => ({
      data: props.data,
      getFilteredData: props.getFilteredData,
      rowKey: props.rowKey,
    }),
  },
  {
    Provider: TemplateColumnsCalculatorProvider,
    props: (props) => ({
      columns: props.columns,
      withCheckbox: props.withCheckbox,
    }),
  },
  {
    Provider: HeaderSizeCalculatorProvider,
    props: (props) => ({ shouldMeasure: props.shouldMeasure }),
  },
];

const Provider = ({ children, ...props }) => {
  return providers.reduceRight(
    (acc, { Provider: ProviderComponent, props: componentProps }) => {
      return (
        <ProviderComponent
          {...(typeof componentProps === 'function'
            ? componentProps(props)
            : componentProps)}
        >
          {acc}
        </ProviderComponent>
      );
    },
    children
  );
};

export default Provider;
